import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../../..';
import StepIndex from '../StepIndex/StepIndex';
import ShowAt from '../../../ShowAt/ShowAt';

export default function TileStatus({ poolTileTitle, stepInfo }) {
  return (
    <div className="d-flex gap-sm flex-wrap">
      <ShowAt at={!!poolTileTitle}>
        <Text text={poolTileTitle} className="legend-name" />
      </ShowAt>
      <StepIndex stepInfo={stepInfo} />
    </div>
  );
}

TileStatus.defaultProps = {
  stepInfo: {},

  poolTileTitle: '',
};

TileStatus.propTypes = {
  poolTileTitle: PropTypes.string,
  stepInfo: PropTypes.object,
};
